module.exports = __webpack_public_path__ + "static/img/icon5.3fff97ef.png";